// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__6yrBi","logo__headers":"Logo_logo__headers__FJIWx","logo__title":"Logo_logo__title__C53Dh","logo__subtitle":"Logo_logo__subtitle__nF+5B"};